export const scrollTo = (
  el: HTMLElement | null,
  parent: HTMLElement | Window | null
) => {
  if (!el) {
    return;
  }

  parent = parent || window;

  const findPos = (el: HTMLElement) => {
    let curtop = 0;

    if (el.offsetParent) {
      do {
        curtop += el.offsetTop;
      } while ((el = el.offsetParent as HTMLElement));
    }
    return curtop;
  };

  parent.scrollTo({
    top: findPos(el),
    left: 0,
    behavior: 'smooth',
  });
};
